// menu icon
import dashboardIcon from "../assets/images/menu/dashboard.svg";
import counselingIcon from "../assets/images/menu/counseling.png";
import taskIcon from "../assets/images/menu/task.svg";
import communityIcon from "../assets/images/menu/community.png";
import attendanceIcon from "../assets/images/menu/attendance.svg";
import workscheduleIcon from "../assets/images/menu/workschedule.svg";
import vacationIcon from "../assets/images/menu/vacation.svg";
import salaryIcon from "../assets/images/menu/salary.svg";
import personIcon from "../assets/images/menu/person.svg";
import electronicIcon from "../assets/images/menu/electronic.svg";
import fundsIcon from "../assets/images/menu/funds.svg";
import electronicBillIcon from "../assets/images/menu/electronic-bill.svg";
import expenseclaimIcon from "../assets/images/menu/expenseclaim.svg";
import uploadIcon from "../assets/images/menu/upload.svg";
import managerIcon from "../assets/images/menu/manager.svg";
import itemIcon from "../assets/images/menu/item.svg";
import clientIcon from "../assets/images/menu/client.svg";
// menu on icon
import dashboardOnIcon from "../assets/images/menu/dashboard-on.svg";
import counselingOnIcon from "../assets/images/menu/counseling-on.png";
import taskOnIcon from "../assets/images/menu/task-on.svg";
import communityOnIcon from "../assets/images/menu/community-on.png";
import attendanceOnIcon from "../assets/images/menu/attendance-on.svg";
import workscheduleOnIcon from "../assets/images/menu/workschedule-on.svg";
import vacationOnIcon from "../assets/images/menu/vacation-on.svg";
import salaryOnIcon from "../assets/images/menu/salary-on.svg";
import personOnIcon from "../assets/images/menu/person-on.svg";
import electronicOnIcon from "../assets/images/menu/electronic-on.svg";
import fundsOnIcon from "../assets/images/menu/funds-on.svg";
import electronicBillOnIcon from "../assets/images/menu/electronic-bill-on.svg";
import expenseclaimOnIcon from "../assets/images/menu/expenseclaim-on.svg";
import uploadOnIcon from "../assets/images/menu/upload-on.svg";
import managerOnIcon from "../assets/images/menu/manager-on.svg";
import itemOnIcon from "../assets/images/menu/item-on.svg";
import clientOnIcon from "../assets/images/menu/client-on.svg";


// tax portal
import taxPayerIcon from "../assets/images/menu/taxPayer.png";
import taxPayerOnIcon from "../assets/images/menu/taxPayer_on.png";

import administrativeCertificate1Icon from "../assets/images/menu/administrativeCertificate_1.png";
import administrativeCertificate1OnIcon from "../assets/images/menu/administrativeCertificate_on_1.png";

import administrativeCertificateIcon from "../assets/images/menu/administrativeCertificate.png";
import administrativeCertificateOnIcon from "../assets/images/menu/administrativeCertificate_on.png";

import reportManagementIcon from "../assets/images/menu/reportManagement.png";
import reportManagementOnIcon from "../assets/images/menu/reportManagement_on.png";

import consultingIcon from "../assets/images/menu/consulting.png";
import consultingOnIcon from "../assets/images/menu/consulting_on.png";

import promotionalSupportIcon from "../assets/images/menu/promotionalSupport.png";
import promotionalSupportOnIcon from "../assets/images/menu/promotionalSupport_on.png";

import loungeIcon from "../assets/images/menu/lounge.png";
import loungeOnIcon from "../assets/images/menu/lounge_on.png";

import listOfTaxCollectorsIcon from "../assets/images/menu/listOfTaxCollectors.png";
import listOfTaxCollectorsOnIcon from "../assets/images/menu/listOfTaxCollectors_on.png";

import employeeSettingIcon from "../assets/images/menu/employeeSetting.png";
import employeeSettingOnIcon from "../assets/images/menu/employeeSetting_on.png";

import taxPortalSettingIcon from "../assets/images/menu/taxPortalSetting.png";
import taxPortalSettingOnIcon from "../assets/images/menu/taxPortalSetting_on.png";

import taxAccountantUsefulSiteIcon from "../assets/images/menu/taxAccountantUsefulSite.png";
import taxAccountantUsefulSiteOnIcon from "../assets/images/menu/taxAccountantUsefulSite_on.png";

import callTaxIcon from "../assets/images/menu/calltax.png";
import callTaxOnIcon from "../assets/images/menu/calltax_on.png";
// import guideIcon from "../assets/images/menu/guide.png";
// import guideOnIcon from "../assets/images/menu/guide_on.png";
import userGuideIcon from "../assets/images/menu/user-guide.png";
import userGuideOnIcon from "../assets/images/menu/user-guide.png";


// LOGO
import logoSvg from "../assets/images/menu/wecake-on.svg";
import logoCloseSvg from "../assets/images/menu/wecake.svg";
import {
  ADMIN_TYPES,
  ALL_TYPES,
  WORK_ADMIN_TYPES
} from "./ROLE";

// TRIAL IMAGES

import TrialVacation from "../assets/images/trial/vacation.png";
import TrialSalary from "../assets/images/trial/salary.png";
import TrialElectronic from "../assets/images/trial/electronic.png";
import TrialFunds from "../assets/images/trial/funds.png";
import TrialElectronicBill from "../assets/images/trial/electronic-bill.png";
import TrialExpenseclaim from "../assets/images/trial/expenseclaim.png";
import TrialUpload from "../assets/images/trial/upload.png";
import TrialManager from "../assets/images/trial/manager.png";
import TrialItem from "../assets/images/trial/item.png";
import TrialClient from "../assets/images/trial/client.png";
import TrialCommunity from "../assets/images/trial/community.png";
import TrialCounseling from "../assets/images/trial/counseling.png";
import TrialTask from "../assets/images/trial/task.png";
import taxAccountantUsefulSiteToggle from "../utils/taxAccountantUsefulSite";
// import { isAdminCompany } from "../utils/auth";
import callTaxConnection from "../utils/callTax";
import { isAdminCompany, isTogetherTax } from "../utils/auth";

export const GLOVAL_MENUS = [
  {
    id: "TAX_PORTAL",
    label: "T",
    // isBeta: true
  },
  {
    id: "BIZ",
    label: "Biz",
  },
  {
    id: "PAY_PORTAL",
    label: "CMS",
    isDev: true,
    // isBeta: true
  }
];

export const ADMIN_MENUS = [
  {
    id: "admin",
    label: "경리대행",
    icon: logoCloseSvg,
    depth: 1,
    onIcon: logoSvg,
    children: [
      {
        label: "전체 기업관리",
        id: "admin-companies",
        path: "/admin/companies?tab=companies",
      },
      {
        label: "파트너관리",
        id: "admin-partners",
        path: "/admin/partners?tab=partners",
      },
      {
        label: "무료버전 기업확인",
        id: "admin-companies",
        path: "/admin/request-companies?tab=request-companies",
      },
      {
        label: "상담신청관리",
        id: "admin-consultings",
        path: "/admin/consultings?tab=consultings",
      },
      {
        label: "무료체험 신청관리",
        id: "admin-consultings",
        path: "/admin/free-trial?tab=free-trial",
      },
      {
        label: "세무게시판",
        id: "admin-taxBoards",
        path: "/admin/tax-boards",
      },
      {
        label: "멤버십 관리",
        id: "admin-membership",
        path: "/admin/membership",
        roles: [1],
      },
      {
        label: "광고 배너 관리",
        id: "admin-ad-manager",
        path: "/admin/ad/manager",
      },
    ],
  }];

export const HOMEPAGE_MENUS = [{
  id: "adminHomePage",
  label: "홈페이지관리",
  icon: logoCloseSvg,
  depth: 1,
  onIcon: logoSvg,
  children: [
    {
      label: "뉴스레터 구독자관리",
      id: "admin-newsletter-subscribe",
      path: "/admin/newsletter/subscribe?tab=subscribe",
    },
    {
      label: "뉴스레터 게시물관리",
      id: "admin-newsletter-board",
      path: "/admin/newsletter/board?tab=board",
    },
    {
      label: "뉴스레터 메일폼관리",
      id: "admin-newsletter-mail-form",
      path: "/admin/newsletter/mail-form?tab=mail-form",
    },
    {
      label: "수신거부 메일관리",
      id: "admin-mail-unsubscribe",
      path: "/admin/unsubscribe",
    },
    {
      label: "1:1 문의관리",
      id: "admin-inquiry",
      path: "/admin/inquiry",
    },
    {
      label: "원격요청관리",
      id: "admin-remotes",
      path: "/admin/remotes",
    },
    {
      label: "채용관리",
      id: "admin-recruit",
      path: "/admin/recruits"
    }
  ]
}];

export const SEMINAR_MENUS = [
  {
    id: "adminSeminar",
    label: "세미나관리",
    icon: logoCloseSvg,
    depth: 1,
    onIcon: logoSvg,
    children: [
      {
        label: "세미나관리",
        id: "admin-seminar",
        path: "/admin/seminar/seminar",
      },
      {
        label: "세미나 시즌관리",
        id: "admin-seminar",
        path: "/admin/seminar/session",
      },
      {
        label: "세미나 모집관리",
        id: "admin-seminar",
        path: "/admin/seminar/recruitment",
      },
      {
        label: "세미나 예약관리",
        id: "admin-seminar-reservation",
        path: "/admin/seminar/reservation",
      },
      {
        label: "세미나 카테고리관리",
        id: "admin-seminar-categoies",
        path: "/admin/seminar/categories",
      },
      {
        label: "요청 세미나관리",
        id: "admin-seminar-request",
        path: "/admin/seminar/request",
      },
      {
        label: "요청 세미나 예약관리",
        id: "admin-seminar-request-reservation",
        path: "/admin/seminar/request-reservation",
      },
    ],
  },
];
export const MANAGER_MENUS = [{
  id: "manager",
  label: "매니저 메뉴",
  icon: managerIcon,
  depth: 1,
  onIcon: managerOnIcon,
  children: [
    {
      label: "내가 관리중인 기업관리",
      id: "managing-companies",
      path: "/managing/companies?tab=companies",
    },
    // {
    //   label: "관리중인 기업 상담",
    //   id: "managing-counseling",
    //   path: "/managing/counseling",
    // },
    {
      label: "요청 기업관리",
      id: "managing-companies",
      path: "/managing/partner-request-companies?tab=partner-request-companies",
    },
    {
      label: "홈페이지 유입관리",
      id: "managing-companies",
      path: "/managing/through-me-companies",
    },
    // id: "admin-companies",
    // path: "/admin/request-companies?tab=request-companies",
    {
      label: "상담신청관리",
      id: "managing-consultings",
      path: "/managing/consultings",
    },
    {
      label: "내 정보관리",
      id: "partner/site",
      path: "/managing/partner",
    },
    {
      label: "담당자 상담관리",
      id: "managing-counseling",
      path: "/managing/counseling",
    },
    {
      label: "고객 정보관리",
      id: "managing-carecompany",
      path: "/managing/carecompany",
    },
    {
      label: "전체공지관리",
      id: "managing-notice",
      path: "/managing/notice-board",
    }
  ],
}];

export const DEV_MENUS = [
  {
    id: "guide",
    label: "DEVELOP",
    icon: "bx bxs-ghost",
    depth: 1,
    onIcon: "bx bxs-ghost",
    children: [{
      label: "Mask",
      path: "/test/mask",
    },
    {
      label: "DatePicker",
      path: "/test/datepicker",
    },
    {
      label: "Buttons",
      path: "/test/buttons",
    },
    {
      label: "Badges",
      path: "/test/badges",
    },
    {
      label: "Content Layout",
      path: "/test/content-layout",
    },
    {
      label: "Checkbox And Radio",
      path: "/test/checkbox-radio",
    },
    {
      label: "Redux And Redux-saga",
      path: "/test/redux",
    },
    {
      label: "Finances Cert",
      path: "/test/finances-cert",
    },
    ],
  },
];

export const MENUS = [
  {
    label: "홈",
    isShow: true,
    isTrial: true,
    isFree: true,
    id: "dashboard",
    icon: dashboardIcon,
    onIcon: dashboardOnIcon,
    depth: 1,
    path: "/dashboard",
    readTypes: ALL_TYPES,
    writeTypes: ADMIN_TYPES
  },
  {
    label: "담당자 상담",
    isHide: true,
    isTrial: false,
    isFree: true,
    text: '담당 세무사 또는 노무사 소통 및 자료공유 게시판',
    id: "counseling",
    trialImage: TrialCounseling,
    icon: counselingIcon,
    depth: 1,
    onIcon: counselingOnIcon,
    children: [
      {
        label: "세무사 상담",
        isHide: true,
        isTrial: false,
        isFree: true,
        code: "TAX_COUNSELING",
        path: "/counseling/tax",
        text: '담당 세무사와 직접 소통 및 자료공유 할 수 있는 게시판',
        readTypes: ADMIN_TYPES,
        writeTypes: ADMIN_TYPES,
      },
      {
        label: "노무사 상담",
        isHide: true,
        isTrial: false,
        isFree: true,
        code: "LABOR_COUNSELING",
        path: "/counseling/labor",
        text: '담당 노무사와 직접 소통 및 자료공유 할 수 있는 게시판',
        readTypes: ADMIN_TYPES,
        writeTypes: ADMIN_TYPES,
      },
    ],
  },
  {
    label: "할일",
    code: "TODO",
    text: '할일은 일반기안 기능만 사용해 보실 수 있습니다.',
    isHide: true,
    isTrial: true,
    isFree: true,
    id: "task",
    icon: taskIcon,
    depth: 1,
    onIcon: taskOnIcon,
    path: "/task",
    readTypes: ALL_TYPES,
    writeTypes: ALL_TYPES,
    trialImage: TrialTask,
  },
  {
    label: "커뮤니티",
    code: "COMMUNITY",
    isHide: true,
    isTrial: false,
    text: '사내 게시판 서비스 자유로운 사용',
    id: "community",
    trialImage: TrialCommunity,
    icon: communityIcon,
    depth: 1,
    onIcon: communityOnIcon,
    path: "/community",
    readTypes: ALL_TYPES,
    writeTypes: ALL_TYPES,
  },
  {
    label: "출퇴근",
    isHide: true,
    isTrial: true,
    isFree: true,
    id: "attendance",
    icon: attendanceIcon,
    depth: 1,
    onIcon: attendanceOnIcon,
    children: [
      {
        label: "나의 출퇴근 기록",
        isHide: true,
        isTrial: true,
        isFree: true,
        code: "COMMUTE_HISTORY",
        path: "/attendance/history",
        readTypes: ALL_TYPES,
        writeTypes: ALL_TYPES,
      },
      {
        label: "출퇴근관리",
        isHide: true,
        isTrial: true,
        isFree: true,
        code: "COMMUTE_MANAGEMENT",
        path: "/attendance/management",
        readTypes: WORK_ADMIN_TYPES,
        writeTypes: WORK_ADMIN_TYPES,
      },
      {
        label: "근로시간관리",
        isHide: true,
        isTrial: true,
        isFree: true,
        code: "WORK_TIME_MANAGEMENT",
        path: "/attendance/work-time",
        readTypes: WORK_ADMIN_TYPES,
        writeTypes: WORK_ADMIN_TYPES,
      },
      {
        label: "부서별 근무 현황",
        isHide: true,
        isTrial: true,
        isFree: true,
        code: "WORK_HISTORY",
        path: "/attendance/work-department",
        readTypes: WORK_ADMIN_TYPES,
        writeTypes: WORK_ADMIN_TYPES,
      },
      {
        label: "출퇴근 장소관리",
        isHide: true,
        isTrial: true,
        isFree: true,
        path: "/attendance/location",
        code: "WORK_PLACE_MANAGEMENT",
        readTypes: ADMIN_TYPES,
        writeTypes: ADMIN_TYPES,
      },
    ],
  },
  {
    label: "근무일정",
    isHide: true,
    isTrial: true,
    isFree: true,
    text: '근무일정 생성 및 관리 ',
    id: "workschedule",
    icon: workscheduleIcon,
    depth: 1,
    onIcon: workscheduleOnIcon,
    children: [{
      label: "근무 일정관리",
      isHide: true,
      isTrial: true,
      isFree: true,
      text: '근무일정 생성을 통한 근태 관리, 회사별 자율 설정',
      path: "/workschedule/management",
      code: "WORK_SCHEDULE_MANAGEMENT",
      readTypes: ADMIN_TYPES,
      writeTypes: ADMIN_TYPES,
    },
    {
      label: "공통 휴일",
      isHide: true,
      isTrial: true,
      isFree: true,
      text: '법정휴일 외 추가적인 휴일 등록 ',
      path: "/workschedule/holiday",
      code: "HOLIDAY",
      readTypes: ADMIN_TYPES,
      writeTypes: ADMIN_TYPES,
    },
    {
      label: "기타 근무 항목 설정",
      isHide: true,
      isTrial: true,
      isFree: true,
      text: '출장 등 특별한 근무일정 생성 및 관리 ',
      path: "/workschedule/otherwork",
      code: "OTHER_WORK_MANAGEMENT",
      readTypes: ADMIN_TYPES,
      writeTypes: ADMIN_TYPES,
    },
    ],
  },
  {
    label: "휴가",
    isHide: true,
    isTrial: false,
    text: '연차에 관한 모든 관리',
    id: "vacation",
    trialImage: TrialVacation,
    icon: vacationIcon,
    depth: 1,
    onIcon: vacationOnIcon,
    children: [{
      label: "휴가 실적 및 계획",
      isHide: true,
      isTrial: false,
      text: '직원 본인의 총 연차, 잔여 연차, 사용된 날짜 확인',
      path: "/vacation/plan",
      code: "VACATION_PLAN",
      readTypes: ALL_TYPES,
      writeTypes: ALL_TYPES,
    },
    {
      label: "휴가 부여 현황",
      isHide: true,
      isTrial: false,
      text: '직원 전체 연차현황 확인 및 추가 휴가 관리 ',
      path: "/vacation/assign-status",
      // code: "VACATION_HISTORY" // 휴가 현황
      code: "ADDED_VACATION_HISTORY",
      readTypes: ADMIN_TYPES,
      writeTypes: ADMIN_TYPES,
    },
    {
      label: "연차 기준관리",
      isHide: true,
      isTrial: false,
      text: '회사 내규 맞춤 설정 연차발생기준 등',
      path: "/vacation/standard",
      code: "VACATION_LEAVE_MANAGEMENT",
      readTypes: ADMIN_TYPES,
      writeTypes: ADMIN_TYPES,
    },
    {
      label: "기타 휴가관리",
      isHide: true,
      isTrial: false,
      text: '연차 외 휴가 카테고리 설정',
      path: "/vacation/other",
      code: "OTHER_VACATION_MANAGEMENT",
      readTypes: ADMIN_TYPES,
      writeTypes: ADMIN_TYPES,
    },
    ],
  },
  {
    label: "급여",
    isHide: true,
    isTrial: false,
    text: '직원의 급여내용 관리 및 급여명세서 조회',
    id: "salary",
    icon: salaryIcon,
    depth: 1,
    onIcon: salaryOnIcon,
    trialImage: TrialSalary,
    children: [{
      label: "나의 급여 조회",
      isHide: true,
      isTrial: false,
      text: '직원 본인의 급여명세서 확인',
      path: "/salary/self",
      code: "SALARY",
      readTypes: ALL_TYPES,
      writeTypes: ALL_TYPES,
    },
    {
      label: "급여 내역관리",
      isHide: true,
      isTrial: false,
      text: '직원 전체 급여대장 확인, 일괄 업로드 및 다운로드',
      path: "/salary/detail",
      code: "SALARY_HISTORY_MANAGEMENT",
      readTypes: ADMIN_TYPES,
      writeTypes: ADMIN_TYPES,
    },
    {
      label: "급여 항목관리",
      isHide: true,
      isTrial: false,
      text: '급여명세서 작성시 필요한 카테고리 회사 맞춤 설정',
      path: "/salary/items",
      code: "SALARY_ITEM_MANAGEMENT",
      readTypes: ADMIN_TYPES,
      writeTypes: ADMIN_TYPES,
    },
    ],
  },
  {
    label: "사람",
    isHide: true,
    isTrial: true,
    isFree: true,
    id: "person",
    icon: personIcon,
    depth: 1,
    onIcon: personOnIcon,
    path: "/person/organization",
    code: "USER",
    readTypes: ALL_TYPES,
    writeTypes: ADMIN_TYPES,
  },
  {
    label: "전자계약",
    isHide: true,
    isTrial: false,
    text: '전자근로계약서, 개인정보이용동의서, 비밀보호서약서 등 전자계약 서식 공유',
    id: "electronic",
    trialImage: TrialElectronic,
    icon: electronicIcon,
    depth: 1,
    onIcon: electronicOnIcon,
    path: "/electronic/labor",
    code: "CONTRACT",
    readTypes: ALL_TYPES,
    writeTypes: ADMIN_TYPES,
    // children: [
    //   {
    //     label: "전자 근로 계약서",
    //   isHide: true,
    //    isTrial: true,
    //     path: "/electronic/labor",
    //   },
    // ],
  },
  {
    label: "자금",
    isHide: true,
    isTrial: false,
    text: '회사 모든 자금흐름 한눈에 파악가능 ',
    id: "funds",
    icon: fundsIcon,
    onIcon: fundsOnIcon,
    depth: 1,
    trialImage: TrialFunds,
    children: [{
      label: "리포트",
      isHide: true,
      isTrial: false,
      text: "매출/매입현황, 월별 손익현황 그래프",
      path: "/funds/report",
      code: "FUND_REPORT",
      readTypes: ADMIN_TYPES,
      writeTypes: ADMIN_TYPES,
    },
    {
      label: "자금 일보",
      isHide: true,
      isTrial: false,
      text: "자금 현황 파악, 기간별 매출/매입현황, 은행계좌 및 카드, 기타거래 금액 확인",
      path: "/funds/overview",
      code: "FUND_JOURNAL",
      readTypes: ADMIN_TYPES,
      writeTypes: ADMIN_TYPES,
    },
    {
      label: "은행 계좌 목록",
      isHide: true,
      isTrial: false,
      text: "사업용 계좌 목록 및 입출금액/잔액 현황",
      path: "/funds/account",
      code: "FUND_BANK_HISTORY",
      readTypes: ADMIN_TYPES,
      writeTypes: ADMIN_TYPES,
    },
    {
      label: "은행 입출금 내역",
      isHide: true,
      isTrial: false,
      text: "카테고리 매핑을 통한 회사 계좌 세부 입출금 내역, 거래처 및 거래사실관리",
      path: "/funds/accout-detail",
      code: "FUND_BANK_HISTORY",
      readTypes: ADMIN_TYPES,
      writeTypes: ADMIN_TYPES,
    },
    {
      label: "신용카드 목록",
      isHide: true,
      isTrial: false,
      text: "사업용 계좌 목록 및 기간별 사용금액 조회",
      path: "/funds/card",
      code: "FUND_CARD_HISTORY",
      readTypes: ADMIN_TYPES,
      writeTypes: ADMIN_TYPES,
    },
    {
      label: "신용카드 내역",
      isHide: true,
      isTrial: false,
      text: "신용카드매출/ 신용카드매입내역을 기간별, 카드사별 조회",
      path: "/funds/card-detail",
      code: "FUND_CARD_HISTORY",
      readTypes: ADMIN_TYPES,
      writeTypes: ADMIN_TYPES,
    },
    {
      label: "기타 거래",
      isHide: true,
      isTrial: false,
      text: "기타 거래",
      path: "/funds/other",
      code: "FUND_BANK_HISTORY",
      readTypes: ADMIN_TYPES,
      writeTypes: ADMIN_TYPES,
    },
    {
      label: "거래처별 채권채무",
      isHide: true,
      isTrial: false,
      text: "은행 거래내역과 거래명세서 및 세금계산서 기반, 모든 채권채무 잔액 및 상세내역 확인",
      path: "/funds/bond-debt",
      code: "FUND_CLAIM_OBLIGATION",
      readTypes: ADMIN_TYPES,
      writeTypes: ADMIN_TYPES,
    },
    {
      label: "카테고리",
      isHide: true,
      isTrial: false,
      text: "회사 계정 별 맞춤형 카테고리",
      path: "/funds/categories",
      code: "FUND_CLAIM_OBLIGATION",
      readTypes: ADMIN_TYPES,
      writeTypes: ADMIN_TYPES,
    },
    ],
  },
  {
    label: "계산서",
    isHide: true,
    isTrial: false,
    text: "거래명세서/전자세금계산서/전자계산서/현금영수증/종이계산서 관리 ",
    id: "electronic-bill",
    trialImage: TrialElectronicBill,
    icon: electronicBillIcon,
    depth: 1,
    onIcon: electronicBillOnIcon,
    children: [
      {
        label: "견적서/발주서",
        isHide: true,
        isTrial: false,
        text: "견적서/발주서발행 및 거래명세서, 세금계산서와 연동발급",
        path: "/electronic/quotation-order",
        code: "TRADE_INVOICE",
        readTypes: ADMIN_TYPES,
        writeTypes: ADMIN_TYPES,
      },
      {
        label: "거래명세서",
        isHide: true,
        isTrial: false,
        text: "거래명세서 관리/매출거래명세서 작성 및 세금계산서 발행, 매입거래명세서 기입을 통한 관리 ",
        path: "/electronic/bill-trade",
        code: "TRADE_INVOICE",
        readTypes: ADMIN_TYPES,
        writeTypes: ADMIN_TYPES,
      },
      {
        label: "전자",
        isHide: true,
        isTrial: false,
        text: "편리한 채권채무 관리를 위한 매출세금계산서 발행, 홈택스 스크래핑 매출/매입 전자",
        path: "/electronic/bill-tax",
        code: "TAX_INVOICE",
        readTypes: ADMIN_TYPES,
        writeTypes: ADMIN_TYPES,
      },
      {
        label: "현금 영수증",
        isHide: true,
        isTrial: false,
        text: "매출 현금영수증 발행 가능 및 홈택스 스크래핑 매입현금영수증 확인 ",
        path: "/electronic/bill-cash",
        code: "CASH_INVOICE",
        readTypes: ADMIN_TYPES,
        writeTypes: ADMIN_TYPES,
      },
      /** @todo text 작성필요 */
      {
        label: "종이",
        isHide: true,
        isTrial: false,
        text: "편의성을 위한 종이",
        path: "/electronic/bill-paper-tax",
        code: "TAX_INVOICE",
        readTypes: ADMIN_TYPES,
        writeTypes: ADMIN_TYPES,
      },
    ],
  },
  {
    label: "경비청구",
    isHide: true,
    isTrial: false,
    text: "지출결의서 작성, 등록된 카드 영수증 간단조회 및 카드영수증 사진 업로드 ",
    id: "expenseclaim",

    trialImage: TrialExpenseclaim,
    icon: expenseclaimIcon,
    depth: 1,
    onIcon: expenseclaimOnIcon,
    path: "/expenseclaim/list",
    code: "EXPENSE",
    readTypes: ADMIN_TYPES,
    writeTypes: ADMIN_TYPES,
  },
  {
    label: "업로드 내역",
    isHide: true,
    isTrial: false,
    text: "회사 거래명세서 및 각종 거래사실에 관한 증빙서류 업로드 관리 및 공유 ",
    id: "upload",
    icon: uploadIcon,
    depth: 1,
    onIcon: uploadOnIcon,
    trialImage: TrialUpload,
    path: "/upload/list",
    code: "UPLOAD_HISTORY",
    readTypes: ADMIN_TYPES,
    writeTypes: ADMIN_TYPES,
  },
  // {
  //   label: "파일 보관함",
  //   isHide: true,
  //  isTrial: true,
  //   id: "files",
  //   icon: uploadIcon,
  // depth: 1,
  //   onIcon: uploadOnIcon,
  //   path: "/files/list",
  //   code: "FILES",
  //   readTypes: ADMIN_TYPES,
  //   writeTypes: ADMIN_TYPES,
  // },
  {
    label: "연말정산",
    isHide: true,
    isTrial: false,
    text: "직원 본인의 연말정산간소화 자료 업로드",
    id: "upload",
    icon: uploadIcon,
    depth: 1,
    onIcon: uploadOnIcon,
    path: "/year-end/list",
    code: "UPLOAD_HISTORY",
    readTypes: ADMIN_TYPES,
    writeTypes: ADMIN_TYPES,
  },
  {
    label: "관리자",
    isHide: true,
    isTrial: false,
    text: '거래회사 기초자료를 설정할 수 있는 페이지',
    id: "manager",
    trialImage: TrialManager,
    icon: managerIcon,
    depth: 1,
    onIcon: managerOnIcon,
    children: [{
      label: "회사 정보관리",
      isHide: true,
      isTrial: false,
      text: '기본적인 사항 및 부가정보 기재, 통장사본 및 인감, 사업자등록증 업로드',
      path: "/manager/company-info",
      code: "COMPANY_MANAGEMENT",
      readTypes: ADMIN_TYPES,
      writeTypes: ADMIN_TYPES,
    },
    {
      label: "업무 담당자관리",
      isHide: true,
      isTrial: false,
      text: '직원 별 업무리스트 생성, 메뉴 권한 세팅',
      path: "/manager/inner-task",
      code: "WORK_MANAGER_MANAGEMENT",
      readTypes: ADMIN_TYPES,
      writeTypes: ADMIN_TYPES,
    },
    {
      label: "외부 담당자관리",
      isHide: true,
      isTrial: false,
      text: '회사 세무대리인 및 노무사 정보 파악',
      path: "/manager/outer-task",
      code: "OUTSIDE_MANAGER_MANAGEMENT", // 외부 담당자 관리,
      readTypes: ADMIN_TYPES,
      writeTypes: ADMIN_TYPES,
    },
    {
      label: "금융 정보 자동 수집",
      isHide: true,
      isTrial: false,
      text: '거래내역 스크래핑을 위한 회사 공인인증서 등록 페이지',
      path: "/manager/financial",
      code: "FINANCE_SCRAPING",
      readTypes: ADMIN_TYPES,
      writeTypes: ADMIN_TYPES,
    },
      // {
      //   label: "사업장 정보관리",
      //   isHide: true,
      //  isTrial: true,
      //   path: "/manager/work-place",
      //   code: "COMPANY_PLACE_MANAGEMENT",
      //   readTypes: ADMIN_TYPES,
      //   writeTypes: ADMIN_TYPES,
      // },
    ],
  },
  {
    label: "품목",
    isHide: true,
    isTrial: false,
    text: '편리한 품목 관리를 위한 품목 정보 등록',
    id: "item",
    trialImage: TrialItem,
    icon: itemIcon,
    depth: 1,
    onIcon: itemOnIcon,
    path: "/item/list",
    code: "PRODUCT",
    readTypes: ALL_TYPES,
    writeTypes: ALL_TYPES,
  },
  {
    label: "거래처",
    isHide: true,
    isTrial: false,
    text: '모든 거래처 기록 자동 스크래핑을 통한 편리한 거래처 관리',
    id: "client",
    icon: clientIcon,
    depth: 1,
    trialImage: TrialClient,
    onIcon: clientOnIcon,
    path: "/client/list",
    code: "COMPANY_ACCOUNT",
    readTypes: ALL_TYPES,
    writeTypes: ALL_TYPES,
  },
  {
    label: "이용자 가이드",
    id: "MENUAL",
    link: "https://obvious-birthday-d04.notion.site/wecake-Biz-v-23-12-1f27f64771b143938fe254ec3f14fd51?pvs=4",
    icon: userGuideIcon,
    depth: 1,
    onIcon: userGuideOnIcon,
    readTypes: ALL_TYPES,
    isShow: true,
    isTrial: true,
    isHide: true,
    isFree: true,
  },
  {
    label: "원격지원",
    id: "REMOTE",
    link: "https://helpu.kr/yds/",
    icon: 'bx bxs-network-chart',
    depth: 1,
    onIcon: 'bx bxs-network-chart',
    readTypes: ALL_TYPES,
    isShow: true,
    isTrial: true,
    isHide: true,
    isFree: true,
  },
];



export const TAX_PORTAL_MENUS = [
  // TAX PORTAL
  {
    id: "tax-dashboard",
    label: "홈",
    depth: 1,
    path: "/tax-portal/tax-dashboard",
    icon: dashboardIcon,
    onIcon: dashboardOnIcon,
  },
  {
    label: "수임관리",
    id: "counseling",
    icon: taxPayerIcon,
    onIcon: taxPayerOnIcon,
    depth: 1,
    children: [
      {
        label: "수금현황",
        code: "TAX_MANAGEMENT",
        path: "/tax-portal/tax-management",
      },
      {
        label: "수임처관리",
        code: "TAX_CUSTODIAN",
        path: "/tax-portal/custodian",
      },
      {
        label: "계약관리",
        code: "LABOR_COUNSELING",
        path: "/tax-portal/contract",
      },
      {
        label: "위케이크 고객관리",
        code: "WECAKE_CUSTOMERS",
        path: "/tax-portal/wecake-customers",
      },
    ],
  },
  {
    label: "업무관리",
    id: "counseling",
    icon: administrativeCertificate1Icon,
    depth: 1,
    onIcon: administrativeCertificate1OnIcon,
    children: [
      // {
      //   label: "경리지원",
      //   code: "MANAGING",
      //   path: "/tax-portal/managing",
      // },      
      {
        label: "업무일정",
        code: "TAX_PORTAL_SCHEDULES",
        path: "/tax-portal/schedules",
      },
      {
        label: "상담관리",
        code: "LABOR_COUNSELING",
        path: "/tax-portal/counseling",
      },
      {
        label: "수임처 공지관리",
        code: "LABOR_COUNSELING",
        path: "/tax-portal/notices",
      },
    ],
  },
  {
    label: "민원증명",
    id: "counseling",
    icon: administrativeCertificateIcon,
    depth: 1,
    onIcon: administrativeCertificateOnIcon,
    path: "/tax-portal/administrative-certificate",
  },
  {
    label: "신고관리",
    id: "counseling",
    // isSoon: isAdminCompany() || isTogetherTax() ? false : true,
    icon: reportManagementIcon,
    depth: 1,
    onIcon: reportManagementOnIcon,
    children: [
      {
        label: "신고현황",
        id: "EXPOSED_INFO",
        path: "/tax-portal/tax-singo",
      },
      {
        label: "신고설정",
        id: "EXPOSED_INFO",
        path: "/tax-portal/tax-singo-configuration",
      },
    ],
  },
  {
    label: "컨설팅",
    id: "TAX_CONSULTING",
    // isSoon: isAdminCompany() ? false : true,
    icon: consultingIcon,
    depth: 1,
    onIcon: consultingOnIcon,
    // path: "/tax-portal/tax-consulting",
    children: [
      {
        label: "컨설팅",
        id: "TAX_CONSULTING_CATEGORIES",
        path: "/tax-portal/tax-consulting",
      },
      {
        label: "컨설팅 협업",
        id: "TAX_CONSULTING_COLLABORATION",
        path: "/tax-portal/tax-consulting-collaboration",
      },
      {
        label: "컨설팅 설정",
        id: "TAX_CONSULTING_SETTING",
        path: "/tax-portal/tax-consulting-setting",
      },
    ],
  },
  {
    label: "부동산세금",
    // isSoon: isAdminCompany() ? false : true,
    id: "counseling",
    icon: callTaxIcon,
    depth: 1,
    onIcon: callTaxOnIcon,
    action: () => {
      callTaxConnection();
    },
  },
  {
    label: "홍보지원",
    id: "counseling",
    icon: promotionalSupportIcon,
    depth: 1,
    onIcon: promotionalSupportOnIcon,
    children: [
      {
        label: "노출 정보관리",
        id: "EXPOSED_INFO",
        path: "/tax-portal/exposed-info",
      },
      {
        label: "홈페이지관리",
        code: "SITE_INFO",
        path: "/tax-portal/site-info",
      },
      {
        label: "뉴스레터",
        code: "NEWS_LETTER",
        path: "/tax-portal/newsletter",
      },
    ],
  },
  {
    label: "4대보험조회",
    id: "counseling",
    icon: administrativeCertificateIcon,
    depth: 1,
    // isDev: isAdminCompany() || isTogetherTax() ? false : true,
    onIcon: administrativeCertificateOnIcon,
    path: "/tax-portal/si4n",
  },
  {
    label: "라운지",
    id: "counseling",
    icon: loungeIcon,
    depth: 1,
    isSoon: true,
    onIcon: loungeOnIcon,
    children: [
      {
        label: "대시보드",
        id: "EXPOSED_INFO",
        isSoon: true,
        path: "/tax-portal/newsletter",
      },
      {
        label: "교육",
        id: "EXPOSED_INFO",
        isSoon: true,
        path: "/tax-portal/exposed-info",
      },
      {
        label: "세미나",
        id: "EXPOSED_INFO",
        isSoon: true,
        path: "/tax-portal/exposed-info",
      },
      {
        label: "세무정보",
        id: "EXPOSED_INFO",
        isSoon: true,
        path: "/tax-portal/exposed-info",
      },
      {
        label: "자료실",
        id: "EXPOSED_INFO",
        isSoon: true,
        path: "/tax-portal/exposed-info",
      },
    ],
  },
  {
    label: "세무인명록",
    id: "EXPOSED_INFO",
    link: "https://www.etaxkorea.net/sub_insa/wecake.php",
    icon: listOfTaxCollectorsIcon,
    depth: 1,
    onIcon: listOfTaxCollectorsOnIcon,
  },
  {
    label: "직원관리",
    id: "counseling",
    icon: employeeSettingIcon,
    depth: 1,
    onIcon: employeeSettingOnIcon,
    children: [
      {
        label: "직원관리",
        code: "TAX_PERSON",
        path: "/tax-portal/person",
      },
    ],
  },
  {
    label: "Wecake T 관리",
    id: "counseling",
    icon: taxPortalSettingIcon,
    depth: 1,
    onIcon: taxPortalSettingOnIcon,
    children: [
      {
        label: "홈택스 설정",
        code: "TAX_COUNSELING",
        path: "/tax-portal/settings/hometax",
      },
      {
        label: "위택스 설정",
        code: "TAX_COUNSELING",
        path: "/tax-portal/settings/wetax",
      },
      {
        label: "4대보험 설정",
        code: "TAX_COUNSELING",
        path: "/tax-portal/settings/si4n?tab=nationalPension",
      },
      {
        label: "전화 및 메신저 연결",
        isSoon: true,
        code: "TAX_COUNSELING",
        path: "/counseling/tax",
      },
    ],
  },
  {
    label: "유용한 사이트",
    id: "counseling",
    icon: taxAccountantUsefulSiteIcon,
    depth: 1,
    onIcon: taxAccountantUsefulSiteOnIcon,
    action: () => {
      taxAccountantUsefulSiteToggle();
    },
  },
  {
    label: "이용자 가이드",
    id: "EXPOSED_INFO",
    icon: userGuideIcon,
    depth: 1,
    onIcon: userGuideOnIcon,
    children: [
      {
        label: "wecake T",
        code: "TAX_COUNSELING",
        link: "https://obvious-birthday-d04.notion.site/wecake-Tax-Platform-b6e8949852874c23aa241668b458ed7d",
      },
      {
        label: "경리지원 업무 프로세스",
        code: "TAX_COUNSELING",
        link: "https://obvious-birthday-d04.notion.site/wecake-5690d74da3bf4171b0bce044732c98f8"
      },
    ],
  },
];

export const PAY_PORTAL_MENUS = [
  // {
  //   label: "홈",
  //   id: "counseling",
  //   icon: dashboardIcon,
  //   onIcon: dashboardOnIcon,
  //   path: "/pay-portal/pay-dashboard",
  //   depth: 1,
  // },
  {
    label: "고객관리",
    id: "counseling",
    icon: taxPayerIcon,
    onIcon: taxPayerOnIcon,
    depth: 1,
    path: "/pay-portal/pay-dashboard",
  },
  {
    label: "CMS관리",
    id: "counseling",
    icon: managerIcon,
    onIcon: managerOnIcon,
    depth: 1,
    path: "/pay-portal/pay-dashboard",
  },
  // {
  //   label: "CMS관리",
  //   id: "counseling",
  //   isSoon: true,
  //   icon: counselingIcon,
  //   depth: 1,
  //   onIcon: counselingOnIcon,
  // },
  // {
  //   label: "간편결제관리",
  //   id: "counseling",
  //   isSoon: true,
  //   icon: counselingIcon,
  //   depth: 1,
  //   onIcon: counselingOnIcon,
  // },
  // {
  //   label: "서비스관리",
  //   id: "counseling",
  //   isSoon: true,
  //   icon: counselingIcon,
  //   depth: 1,
  //   onIcon: counselingOnIcon,
  //   children: [
  //     {
  //       label: "서비스 정보",
  //       id: "EXPOSED_INFO",
  //       isSoon: true,
  //       path: "/tax-portal/newsletter",
  //     },
  //     {
  //       label: "가입자 관리",
  //       id: "EXPOSED_INFO",
  //       isSoon: true,
  //       path: "/tax-portal/newsletter",
  //     },
  //     {
  //       label: "사용자 관리",
  //       id: "EXPOSED_INFO",
  //       isSoon: true,
  //       path: "/tax-portal/newsletter",
  //     },
  //   ],
  // },
  // {
  //   label: "결제관리",
  //   id: "counseling",
  //   isSoon: true,
  //   icon: counselingIcon,
  //   depth: 1,
  //   onIcon: counselingOnIcon,
  //   children: [
  //     {
  //       label: "CMS",
  //       id: "EXPOSED_INFO",
  //       isSoon: true,
  //       path: "/tax-portal/newsletter",
  //     },
  //     {
  //       label: "신용카드",
  //       id: "EXPOSED_INFO",
  //       isSoon: true,
  //       path: "/tax-portal/newsletter",
  //     },
  //     {
  //       label: "간편결제",
  //       id: "EXPOSED_INFO",
  //       isSoon: true,
  //       path: "/tax-portal/newsletter",
  //     },
  //   ],
  // },
  // {
  //   label: "정산관리",
  //   id: "counseling",
  //   isSoon: true,
  //   icon: counselingIcon,
  //   depth: 1,
  //   onIcon: counselingOnIcon,
  //   children: [
  //     {
  //       label: "현황",
  //       id: "EXPOSED_INFO",
  //       isSoon: true,
  //       path: "/tax-portal/newsletter",
  //     },
  //     {
  //       label: "미수관리",
  //       id: "EXPOSED_INFO",
  //       isSoon: true,
  //       path: "/tax-portal/newsletter",
  //     },
  //     {
  //       label: "리포트",
  //       id: "EXPOSED_INFO",
  //       isSoon: true,
  //       path: "/tax-portal/newsletter",
  //     },
  //   ],
  // },
];


// export const NEWSLETTER_MENUS = [{
//   id: "manager",
//   label: "Wepick",
//   onIcon: logoSvg,
//   icon: logoCloseSvg,
//   depth: 1,
//   children: [
//     {
//       label: "메일폼관리",
//       id: "wepick-mail-form",
//       path: "/wepick/mail-form",
//     },
//     {
//       label: "구독자관리",
//       id: "wepick-subscriber",
//       path: "/wepick/subscriber",
//     },
//   ]
// }];